import { NavigateOptions, PrefetchOptions } from "next/dist/shared/lib/app-router-context.shared-runtime";
import { useRouter as nextRouter, usePathname } from "next/navigation";
import Nprogress from 'nprogress';
import { useEffect } from "react";

export default function useRouter() {
  const router = nextRouter();
  const pathname = usePathname();

  useEffect(() => {
    Nprogress.done();
  }, [pathname]);

  function push(path: string) {
    if (path !== pathname) {
      Nprogress.start();
      router.push(path);
    }
  }

  function back() {
    Nprogress.start();
    router.back();
  }

  function start() {
    Nprogress.start();
  }


  function forward() {
    router.forward();
  }

  function refresh() {
    router.refresh();
  }

  function replace(href: string, options?: NavigateOptions) {
    router.replace(href, options);
  }

  function prefetch(href: string, options?: PrefetchOptions) {
    router.prefetch(href, options);
  }

  return { pathname, push, back, forward, refresh, replace, prefetch, start };
}
